import { Button, Flex, FormControl, Select, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";

export default function TablePagination(props) {
  const {
    pageSize,
    rows,
    gotoPage,
    canPreviousPage,
    pageOptions,
    pageIndex,
    canNextPage,
    pageCount,
    irParaPagina,
    selecionarTotalItens,
    currentPage,
    totalItems,
    entidade,
    loading,
  } = props;

  useEffect(() => {
    if (pageOptions.length < currentPage) {
      irParaPagina(0);
      gotoPage(0);
    }
  }, [pageOptions, currentPage, gotoPage, irParaPagina]);

  return (
    <Flex
      flexDir={{
        base: "column-reverse",
        md:
          entidade === "relatorio-servico-acolhimento" ||
          entidade === "relatorio-crianca-adolescente-geral"
            ? "column"
            : "row",
        xl: "row",
      }}
      alignItems="center"
      justifyContent="space-between"
      mt="20px"
    >
      <Flex flexDir="row" mt={{ base: "20px", md: 0 }}>
        <FormControl flexDir="column">
          <Flex flexDir="row" alignItems={"center"}>
            <Text mr={2}>Visualizando: </Text>
            <Select
              id="porPagina"
              backgroundColor="white"
              value={pageSize}
              onChange={(e) => selecionarTotalItens(Number(e.target.value))}
              disabled={loading}
            >
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
            </Select>
            <Text ml={2}>de </Text>
            <Text ml={2}>
              {" "}
              {entidade &&
              (entidade === "crianca" ||
                entidade === "relatorio-pendencia" ||
                entidade === "fila-processamento" ||
                entidade === "crianca-pendencia" ||
                entidade === `avisos${props?.index}` ||
                entidade === "relatorio-crianca-adolescente" ||
                entidade === "relatorio-servico-acolhimento" ||
                entidade === "relatorio-crianca-adolescente-geral" ||
                entidade === "auditoria-servico" ||
                entidade === "auditoria-crianca" ||
                entidade === "auditoria-servico-detalhe" ||
                entidade === "auditoria-crianca-detalhe")
                ? totalItems
                : rows.length}{" "}
            </Text>
            <Text ml={2}>registro(s) </Text>
          </Flex>
        </FormControl>
      </Flex>
      <Flex flexDir="row">
        <Button
          backgroundColor={"white"}
          borderX={"1px solid #C4C4C4"}
          roundedRight={0}
          borderY={"1px solid #C4C4C4"}
          roundedLeft={10}
          onClick={() => irParaPagina(0)}
          disabled={!canPreviousPage || loading}
        >
          {"<<"}
        </Button>
        <Button
          backgroundColor={"white"}
          rounded={0}
          borderY={"1px solid #C4C4C4"}
          onClick={() => irParaPagina(pageIndex - 1)}
          disabled={!canPreviousPage || loading}
        >
          {"<"}
        </Button>
        {pageOptions.length >= 1 ? (
          <Flex flexDir={"row"}>
            {canPreviousPage && pageIndex > 1 && (
              <Button
                backgroundColor={"white"}
                borderX={"1px solid #C4C4C4"}
                rounded={0}
                borderY={"1px solid #C4C4C4"}
                onClick={() => irParaPagina(pageIndex - 2)}
                disabled={loading}
              >
                {pageIndex - 1}
              </Button>
            )}

            {canPreviousPage && (
              <Button
                backgroundColor={"white"}
                borderX={"1px solid #C4C4C4"}
                rounded={0}
                borderY={"1px solid #C4C4C4"}
                onClick={() => irParaPagina(pageIndex - 1)}
                disabled={loading}
              >
                {pageIndex}
              </Button>
            )}

            <Button
              rounded={0}
              backgroundColor={"#4E9295"}
              _hover={"#169499"}
              color={"white"}
              borderY={"1px solid #C4C4C4"}
              onClick={() => irParaPagina(pageIndex)}
              disabled={loading}
            >
              {pageIndex + 1}
            </Button>
            {canNextPage && (
              <Button
                backgroundColor={"white"}
                rounded={0}
                borderY={"1px solid #C4C4C4"}
                borderX={"1px solid #C4C4C4"}
                onClick={() => irParaPagina(pageIndex + 1)}
                disabled={loading}
              >
                {pageIndex + 2}
              </Button>
            )}
            {canNextPage && pageIndex + 2 < pageCount && (
              <Button
                backgroundColor={"white"}
                rounded={0}
                borderY={"1px solid #C4C4C4"}
                borderX={"1px solid #C4C4C4"}
                onClick={() => irParaPagina(pageIndex + 2)}
                disabled={loading}
              >
                {pageIndex + 3}
              </Button>
            )}
          </Flex>
        ) : (
          <></>
        )}
        <Button
          backgroundColor={"white"}
          borderY={"1px solid #C4C4C4"}
          rounded={0}
          onClick={() => irParaPagina(pageIndex + 1)}
          disabled={!canNextPage || loading}
        >
          {">"}
        </Button>
        <Button
          backgroundColor={"white"}
          roundedRight={10}
          borderX={"1px solid #C4C4C4"}
          borderY={"1px solid #C4C4C4"}
          roundedLeft={0}
          onClick={() => irParaPagina(pageCount - 1)}
          disabled={!canNextPage || loading}
        >
          {">>"}
        </Button>
      </Flex>
    </Flex>
  );
}
